import ViewHeading from '../../components/ViewHeading.jsx';
/** Misma pantalla de tarjetas que ModulesGrid, con módulos externos. */
export default function ProveedorModulesView({ modules, onSelect }) {
  return (
    <>
      <ViewHeading title="Módulos" description="Elige un módulo para consultar las operaciones de tu empresa." />
      <div className="modules-grid">
        {modules.map((module) => (
          <button key={module.id} type="button" className="module-card" onClick={() => onSelect(module.id)}>
            <span className="module-card-icon">
              <span className="material-symbols-rounded" aria-hidden="true">{module.icon}</span>
            </span>
            <h3 className="module-card-title">{module.title}</h3>
            <p className="module-card-desc">{module.desc}</p>
            <span className="module-card-go">
              Entrar<span className="material-symbols-rounded" aria-hidden="true">arrow_forward</span>
            </span>
          </button>
        ))}
        {modules.length === 0 && <p className="view-heading-sub" role="status">Este perfil no tiene módulos habilitados.</p>}
      </div>
    </>
  );
}
